import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { css } from "styled-components";

export interface OrderDetailsShippingMethodStyles {
    titleText?: TypographyProps;
    description?: TypographyProps;
    descritionWrapper?: InjectableCss;
    wrapper?: InjectableCss;
}

export const shippingMethodStyles: OrderDetailsShippingMethodStyles = {
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
            font-size: 16px;
            padding-top: 10px;
        `,
    },
};

const styles = shippingMethodStyles;

const OrderDetailsShippingMethodFreight: React.FunctionComponent = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }

    let shipDetails;
    if (order?.shipViaDescription !== undefined) {
        try {
            shipDetails = JSON.parse(order?.shipViaDescription);
        } catch (e) {
            shipDetails = "";
        }
    }

    const [isAnnualReturnsOrder, setIsAnnualReturnsOrder] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get("IsAnnualReturnsOrder") === "true") {
            setIsAnnualReturnsOrder(true);
        }
    }, []);

    const hasShippingMethod =
        (order.fulfillmentMethod === FulfillmentMethod.Ship || !order.fulfillmentMethod) && order.shipCode;

    if (!hasShippingMethod || isAnnualReturnsOrder) {
        return null;
    }

    return (                      
           
    <StyledWrapper {...styles.wrapper}>      
      <StyledWrapper className="description-wrapper" {...styles.descritionWrapper}>
          <Typography className="text-body-md"><strong> {translate("Freight Terms")}:</strong> {shipDetails?.fright}</Typography>         
      </StyledWrapper>
  </StyledWrapper>
            
            
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsShippingMethodFreight,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
